import { GroupedNodes, NodeStruct } from '@/types/node-types';

/**
 * Find a node struct in the grouped catalog by its node_id.
 *
 * The catalog is keyed by category (e.g. "agent", "output") with each
 * category containing an array of node structs. This helper performs
 * a flat search across all categories.
 */
export function findCatalogStruct(
  groupedNodes: GroupedNodes,
  nodeId: string,
): NodeStruct | null {
  for (const structs of Object.values(groupedNodes)) {
    if (!Array.isArray(structs)) continue;
    const match = structs.find((s) => s.node_id === nodeId);
    if (match) return match;
  }
  return null;
}
